export const VIDEO_MAX_DIMENSIONS = 4096;
export const IMAGE_MAX_DIMENSIONS = 8192;
export const IMAGE_MAX_DIMENSIONS_EXTENDED = 12288;
export const VIDEO_MAX_CHARACTERS = 450;
export const IMAGE_MAX_CHARACTERS = 4000;
export const CREATIVE_MAX_DURATION_SECONDS = 300;
